/*
 * ButtonGroup.ts
 */
export class ButtonGroup {
    constructor(noSelectionPermitted = false) {
        this.noSelectionPermitted = noSelectionPermitted;
        this.create();
    }
    create() {
        this.currentSelection = null;
        this.createButtons();
    }
    createButtons() {
        this.buttons = [];
    }
    removeAll() {
        let button;
        for (let i = 0; i < this.buttons.length; i++) {
            button = this.buttons[i];
            button.setGroup(null);
            button.setSelected(false);
        }
        this.currentSelection = null;
        this.createButtons();
    }
    add(button) {
        button.setGroup(this);
        this.buttons.push(button);
        if (!this.noSelectionPermitted && !this.currentSelection) {
            this.setSelected(button, true);
        }
    }
    remove(button) {
        if (this.contains(button)) {
            button.setGroup(null);
            let index = this.buttons.indexOf(button);
            this.buttons.splice(index, 1);
            if (button == this.currentSelection) {
                this.currentSelection = null;
            }
        }
    }
    contains(button) {
        return this.buttons.indexOf(button) >= 0;
    }
    setSelected(button, selected) {
        if (selected) {
            this.selectedTarget = null;
            if (button != this.currentSelection) {
                let previousSelection = this.currentSelection;
                this.currentSelection = button;
                if (previousSelection) {
                    previousSelection.setSelected(false);
                }
                this.currentSelection.setSelected(true);
            }
        }
        else {
            if (this.noSelectionPermitted) {
                if (this.selectedTarget != button) {
                    this.selectedTarget = button;
                    button.setSelected(false);
                    if (button == this.currentSelection) {
                        this.currentSelection = null;
                    }
                }
            }
        }
    }
    clearSelection() {
        if (this.noSelectionPermitted && this.currentSelection) {
            this.currentSelection.setSelected(false);
            this.currentSelection = null;
            this.selectedTarget = null;
        }
    }
    isSelected(button) {
        return button == this.currentSelection;
    }
    hasSelection() {
        return this.currentSelection != null;
    }
    getSelection() {
        return this.currentSelection;
    }
}
//# sourceMappingURL=ButtonGroup.js.map